import { render, staticRenderFns } from "./invitationTask.vue?vue&type=template&id=6241a134&scoped=true&"
import script from "./invitationTask.vue?vue&type=script&lang=js&"
export * from "./invitationTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241a134",
  null
  
)

export default component.exports